import { project2BaseUrl } from "./remoteClient";

export async function requestDeliveryFormats(token) {
    return await project2BaseUrl.get('administration/getDeliveryFormats', {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
}